import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';
import {AccountDefinition} from "./account-definition";
import OpenClose = AccountDefinition.OpenClose;

export class AcceptanceRule {
  @JsonProperty()
  id: number = -1;
  @JsonProperty()
  disabled: boolean;
  @JsonProperty()
  giveInMessage: string | undefined;
  @JsonProperty()
  giveInBrokerCode: string | undefined;
  @JsonProperty()
  giveInBrokerCodeInclude: boolean;
  @JsonProperty()
  ruleType: AcceptanceRule.AcceptanceRuleType;
  @JsonProperty()
  tradeType: AcceptanceRule.AcceptanceRuleTradeType;
  @JsonProperty()
  contractList: string | undefined;
  @JsonProperty()
  contractListInclude: boolean;
  @JsonProperty()
  allFutures: boolean;
  @JsonProperty()
  allOptions: boolean;
  @JsonProperty()
  accountCode: string | undefined;
  @JsonProperty()
  exchangeCode: string | undefined;
  @JsonProperty()
  clearingHouse: string | undefined;
  @JsonProperty()
  customerId: number;
  @JsonProperty()
  owner: string | undefined;
  @JsonProperty()
  accountTypeCode: string | undefined;
  @JsonProperty()
  accountReference1: string | undefined;
  @JsonProperty()
  accountReference2: string | undefined;
  @JsonProperty()
  accountReference3: string | undefined;
  @JsonProperty()
  giveUpBrokerCode: string | undefined;
  @JsonProperty()
  giveUpMessage: string | undefined;
  @JsonProperty()
  giveupMessage2: string | undefined;
  @JsonProperty()
  giveupMessage3: string | undefined;
  @JsonProperty()
  giveupAccountType: string | undefined;
  @JsonProperty()
  giveUpCommission: string | undefined;
  @JsonProperty()
  giveupCommissionTolerance: number;
  @JsonProperty()
  executionFee: string | undefined;
  @JsonProperty()
  openCloseForFutures: OpenClose;
  @JsonProperty()
  openCloseForOptions: OpenClose;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  volumeLimit: number;
  @JsonProperty()
  positionLimit: number;
  @JsonProperty()
  source: string | undefined;
  @JsonProperty()
  clearingBroker: string | undefined;

}

export module AcceptanceRule {
  export enum AcceptanceRuleType {
    ACCEPT_ALL = 'ACCEPT_ALL',
    WAIT_APPROVAL = 'WAIT_APPROVAL',
    CLEARED = 'CLEARED'
  }

  export enum AcceptanceRuleTradeType {
    ALL = 'ALL',
    GIVE_IN = 'GIVE_IN',
    EXECUTED = 'EXECUTED'
  }
}
